// eslint-disable jsx-a11y/alt-text
import watchShowcaseImage1 from 'assets/total-eclipse/showcase/1.jpg'
import watchShowcaseImage2 from 'assets/total-eclipse/showcase/2.jpg'
import watchShowcaseImage3 from 'assets/total-eclipse/showcase/3.jpg'
import watchShowcaseImage4 from 'assets/total-eclipse/showcase/4.jpg'
import watchShowcaseImage5 from 'assets/total-eclipse/showcase/5.jpg'
import watchShowcaseImage6 from 'assets/total-eclipse/showcase/6.jpg'
import watchShowcaseImage7 from 'assets/total-eclipse/showcase/7.jpg'
import watchShowcaseImage8 from 'assets/total-eclipse/showcase/8.jpg'
import watchShowcaseImage9 from 'assets/total-eclipse/showcase/9.jpg'
import watchShowcaseImage10 from 'assets/total-eclipse/showcase/10.jpg'
import watchShowcaseImage11 from 'assets/total-eclipse/showcase/11.jpg'
import watchShowcaseImage12 from 'assets/total-eclipse/showcase/12.jpg'
import watchShowcaseImage13 from 'assets/total-eclipse/showcase/13.jpg'
import watchShowcaseImage14 from 'assets/total-eclipse/showcase/14.jpg'
import watchDetailImage1 from 'assets/total-eclipse/watch-details/1.jpg'
import watchDetailImage2 from 'assets/total-eclipse/watch-details/2.jpg'
import watchDetailImage3 from 'assets/total-eclipse/watch-details/3.jpg'
import watchFaceImage from 'assets/total-eclipse/watch_face.jpg'
import watchFaceAngledImage from 'assets/total-eclipse/watch_face_angled.jpg'
import watchesImage from 'assets/total-eclipse/watches.jpg'
import Head from 'next/head'

import Footer from 'components/total-eclipse/Footer'
import TAImage from 'components/total-eclipse/Image'
import ImageCarousel from 'components/total-eclipse/ImageCarousel'
// import Image from 'next/image'
import Introduction from 'components/total-eclipse/Introduction'
import Spacer from 'components/total-eclipse/Spacer'
import Text from 'components/total-eclipse/Text'

import { Root } from './total-eclipse.style'

export default function Page() {
  return (
    <>
      <Head>
        <title>The Total Eclipse by The Armoury and H. Moser & Cie.</title>
        <meta
          name="description"
          content="The Armoury in collaboration with H Moser & Cie. has created the TOTAL ECLIPSE, a limited edition watch based on H Moser’s Endeavour Small Seconds and inspired by the celestial event of a Total Solar Eclipse."
        />
        {/* Facebook Meta Tags */}
        <meta property="og:url" content="https://watches.thearmoury.com/total-eclipse/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="The Total Eclipse by The Armoury and H. Moser & Cie." />
        <meta
          property="og:description"
          content="The Armoury in collaboration with H Moser & Cie. has created the TOTAL ECLIPSE, a limited edition watch based on H Moser’s Endeavour Small Seconds and inspired by the celestial event of a Total Solar Eclipse."
        />
        <meta property="og:image" content="https://watches.thearmoury.com/assets/total-eclipse/social.jpg" />
        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="watches.thearmoury.com" />
        <meta property="twitter:url" content="https://watches.thearmoury.com/total-eclipse/" />
        <meta name="twitter:title" content="The Total Eclipse by The Armoury and H. Moser & Cie." />
        <meta
          name="twitter:description"
          content="The Armoury in collaboration with H Moser & Cie. has created the TOTAL ECLIPSE, a limited edition watch based on H Moser’s Endeavour Small Seconds and inspired by the celestial event of a Total Solar Eclipse."
        />
        <meta name="twitter:image" content="https://watches.thearmoury.com/assets/total-eclipse/social.jpg" />

        <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32" />
        <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16" />
        <link rel="manifest" type="image/png" href="/manifest.json" />
        <link rel="mast-icon" href="/safari-pinned-tab.svg" />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link rel="stylesheet" href="https://use.typekit.net/dbw1jpz.css" />
      </Head>

      <Root>
        <Introduction />
        <Spacer />
        <Text header="Two Materials">
          <p>
            The watch features a 38mm steel case, Vantablack® dial with inset indices, Breguet hands, seconds sub-dial
            and is available in two versions, one with steel accents and one with 5N red gold accents.
          </p>
        </Text>
        <TAImage src={watchesImage} />
        <Text header="Vantablack®">
          <p>
            The watches’ unique dial draws on <span className="whitespace-nowrap">H Moser &amp; Cie’s</span> expertise
            with Vantablack®, a coating made of light-absorbing carbon nanotubes, applied on the dial of the watch. It
            is the darkest man-made substance in the world. The indices visible on the dial are holes in the Vantablack®
            layer that reveal the dial plate underneath.
          </p>

          <p>
            The Breguet hands and seconds sub dial are our nod to classic watchmaking and are especially striking as
            they float over the void-like dial.
          </p>
        </Text>
        <TAImage src={watchFaceImage} />
        <Spacer size="sm" />
        <Text header="The Concept">
          <p>
            During a total solar eclipse, the corona of the sun, i.e. its fiery halo, becomes visible to the human eye.
            In order to recreate this effect, we have added a polished inner bezel of either steel or 5N red gold. The
            steel inner bezel visually deepens the blackness of the dial while the 5N red gold bezel provides a bright
            shimmer that is especially reminiscent of the sun’s fire.
          </p>
        </Text>
        <TAImage src={watchFaceAngledImage} />
        <Spacer />
        <Text header="The Endeavour Small Seconds">
          <p>
            The case of the watch is based on <span className="whitespace-nowrap">H Moser &amp; Cie’s</span> Endeavour
            series, with its distinctive scalloped sides and downturned lugs, resized at The Armoury’s request to an
            elegant 38mm diameter that pairs well with any formal or casual outfit.
          </p>
        </Text>
        <ImageCarousel images={[watchDetailImage1, watchDetailImage2, watchDetailImage3]} />
        <Spacer />
        <Text header="Style and Proportion">
          <p>
            The result of our collaboration is a fine, discreet watch made possible by{' '}
            <span className="whitespace-nowrap">H Moser’s</span> outstanding watchmaking and The Armoury’s distinctive
            sense of style and proportion. It is a versatile addition to any wardrobe.
          </p>
        </Text>
        <ImageCarousel
          images={[
            watchShowcaseImage1,
            watchShowcaseImage2,
            watchShowcaseImage3,
            watchShowcaseImage4,
            watchShowcaseImage5,
            watchShowcaseImage6,
            watchShowcaseImage7,
            watchShowcaseImage8,
            watchShowcaseImage9,
            watchShowcaseImage10,
            watchShowcaseImage11,
            watchShowcaseImage12,
            watchShowcaseImage13,
            watchShowcaseImage14,
          ]}
        />
        <Spacer />
        <Footer />
      </Root>
    </>
  )
}

Page.getLayout = function getLayout(page) {
  return <div className="overflow-x-hidden">{page}</div>
}

// eslint-enable jsx-a11y/alt-text
